<i18n>
{
	"en": {
		"goodsTypes": "Goods Types",
		"selectGoodsTypes": "Select goods types",
		"goodsTypesSelected": "All goods types | {count} goods type selected | {count} goods types selected"
	},
	"no": {
		"goodsTypes": "Godstyper",
		"selectGoodsTypes": "Velg godstyper",
		"goodsTypesSelected": "Alle godstyper | {count} godstype valgt | {count} godstyper valgt"
	}
}
</i18n>
<template>
	<t-select
		:items="goodsTypes"
		:label="label || $t('goodsTypes')"
		:selectedItems="selectedItems"
		:disabled="disabled"
		width="100%"
		v-bind="$attrs"
		relative
		@change="onChange"
	>
		<template #displayedValue="{popoverShow}">
			{{ popoverShow ? $t('selectGoodsTypes') : $tc('goodsTypesSelected', selectedItems.length) }}
		</template>
		<template #optionItem="{ item, isSelected }">
			<t-menu-icon-option-item
				:key="item.id"
				:icon="item.icon"
				:value="item"
				:displayName="item.name"
				:selected="isSelected"
			/>
		</template>
	</t-select>
</template>

<script>
import { mapState, mapActions } from './store/goodsTypes.store';

export default {
	name: 'GoodsTypesSelect',
	inheritAttrs: false,
	props: {
		label: String,
		selectedItems: Array,
		popoverVisible: String,
		popoverHidden: String,
	},
	computed: {
		...mapState(['goodsTypes']),
		disabled() {
			return !this.goodsTypes || this.goodsTypes.length === 0;
		}
	},
	mounted() {
		this.getGoodsTypes();
	},
	methods: {
		...mapActions(['getGoodsTypes']),
		onChange(event) {
			this.$emit('change', event);
		}
	},
};

</script>

<style lang="scss" scoped>

</style>
